document.addEventListener('DOMContentLoaded', () => {
    const badges = document.querySelector('.review-badges');

    if (!badges || window.innerWidth > 768) return;

    badges.classList.add('is-active');

    window.addEventListener('scroll', () => {
        if (window.scrollY > 10) {
            badges.classList.remove('is-active');
        } else {
            badges.classList.add('is-active');
        }
    }, { passive: true });
});